import React from 'react';
import { useIntl } from 'react-intl';

import { Option, Select } from 'carbon-react/lib/components/select';

import { translateUserRole } from '@futrli/backend-messages/common/user-roles';

import { UserFormController } from '../types';
import { UserRoleExplanations } from './user-role-explanations';

import styles from './user-role-select.scss';

interface UserRoleSelectProps {
  disableRole?: boolean;
  form: UserFormController;
}

export const UserRoleSelect = ({ disableRole = false, form }: UserRoleSelectProps) => {
  const intl = useIntl();

  return (
    <>
      <div className={styles.userRoleSelect}>
        <Select
          disabled={disableRole}
          error={form.errors.role?.message}
          id="user-role"
          label={intl.formatMessage({ id: 'common.role', defaultMessage: 'Role' })}
          mb={3}
          name="user-role"
          onBlur={form.revalidate}
          onChange={form.onChangeRole}
          placeholder={intl.formatMessage({
            id: 'common.predict.please_select',
            defaultMessage: 'Please select...'
          })}
          required
          value={form.roleId}
        >
          {form.roles.map(role => (
            <Option key={role.id} text={translateUserRole(role.name, intl)} value={role.id} />
          ))}
        </Select>
      </div>
      <UserRoleExplanations roleId={form.roleId} />
    </>
  );
};
